import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';
import PropTypes from 'prop-types';
import AdminCtaRow from './adminCtaRow.js';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

const AdminCtas = ({ setLoading, setError, match }) => {
  const [sortBy, setSortBy] = useState(null);
  const [ctas, setCtas] = useState([]);

  const v2 = match.params.apiVersion === '2';

  useEffect(() => {
    getCtas();
  }, []);

  function getCtas(newSortParam) {
    setLoading(true);
    const apiCall = v2 ? apiCalls.getCtasV2 : apiCalls.getCtas;
    apiCall({ sortBy: newSortParam || sortBy }, v2)
      .then((result) => {
        setCtas(result.data.ctas);
        setLoading(false);
      })
      .catch((errors) => {
        setLoading(false);
        setError(utils.getErrorMessageFromResponse(errors));
      });
  }

  function setSortMethod(newSortBy) {
    let sortParam;

    switch (newSortBy) {
      case 'title':
        sortParam = sortBy === 'titleAsc' ? 'titleDesc' : 'titleAsc';
        break;
      case 'type':
        sortParam = sortBy === 'typeAsc' ? 'typeDesc' : 'typeAsc';
        break;
      case 'dateCreated':
        sortParam = sortBy === 'dateCreatedAsc' ? 'dateCreatedDesc' : 'dateCreatedAsc';
        break;
      case 'id':
      default:
        sortParam = sortBy === 'idAsc' ? 'idDesc' : 'idAsc';
    }

    setSortBy(sortParam);
    getCtas(sortParam);
  }
  const { formatMessage } = useIntl();

  return (
    <div>
      <Helmet>
        <title>{formatMessage({ id: 'admin.ctas.title' })}</title>
      </Helmet>

      <h3>
        <FormattedMessage id={'admin.ctas.title'} />
      </h3>

      <div className="m-b-3">
        <Link className="btn btn-default m-r-2" to="/admin/ctas/create">
          <FormattedMessage id={'admin.button.create'} />
        </Link>
        <Link className="btn btn-default" to={v2 ? '/admin/ctas' : '/admin/ctas/2'}>
          <FormattedMessage id={v2 ? 'admin.ctas.v1' : 'admin.ctas.v2'} />
        </Link>
      </div>

      <table className="table table-striped admin__table">
        <thead>
          <tr>
            <th onClick={() => setSortMethod('id')} className="sortable" scope="col">
              Id
            </th>
            <th scope="col">
              <i className="fa fa-image" />
            </th>
            <th onClick={() => setSortMethod('type')} className="sortable" scope="col">
              Type
            </th>
            <th onClick={() => setSortMethod('title')} className="sortable" scope="col">
              Title
            </th>
            <th scope="col">Category</th>
            <th scope="col">URL</th>
            <th onClick={() => setSortMethod('dateCreated')} className="sortable" scope="col">
              Date created
            </th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {ctas.map((cta, index) => (
            <AdminCtaRow cta={cta} key={index} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

AdminCtas.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

AdminCtas.defaultProps = {};

export default AdminCtas;
